import { invokeAuthed } from './functionAuth';

const FALLBACK = 'AI settings are unavailable right now. Please try again.';
const NOT_DEPLOYED = 'The AI settings service has not been deployed to this project yet.';

const call = async (body) => {
  const { data, error } = await invokeAuthed('ai-settings', body);
  if (error) {
    let message = error.context?.status === 404 ? NOT_DEPLOYED : FALLBACK;
    try {
      const payload = await error.context.json();
      if (payload?.error) message = payload.error;
      else if (payload?.code && message === FALLBACK) message = `${FALLBACK} (HTTP ${error.context.status}, ${payload.code})`;
    } catch (e) {
      // Keep the message chosen above.
    }
    throw new Error(message);
  }
  if (!data || data.error) throw new Error(data?.error || FALLBACK);
  return data;
};

// The API key is sent once when saving and is never returned by the server.
export const aiSettingsService = {
  status: () => call({ action: 'status' }),
  setMode: (mode) => call({ action: 'set_mode', mode }),
  saveKey: (apiKey) => call({ action: 'save_key', apiKey }),
  recheck: () => call({ action: 'recheck' }),
  removeKey: () => call({ action: 'remove_key' })
};